import React from 'react';

import { SupportedLanguage } from 'lib/lexemes/supported-languages';

type Props = {
  title: string;
  children: React.ReactNode;
  lang?: SupportedLanguage;
};

const FaqContainer: React.FC<Props> = ({ title, children, lang }) => {
  return (
    <div className="faq">
      <h2 className="faq__header" lang={lang}>
        {title}
      </h2>
      <div className="faq__body">{children}</div>
    </div>
  );
};

export default FaqContainer;
